import React from "react"

import HeaderPopup from "./HeaderPopup"
import { container } from "@components/wrapper"
import clsx from "clsx"
import { LinkHead } from "../HeaderComponent"

export function CorporatePopover({ transparent }: { transparent?: boolean }) {
  const PopoverComponent = () => {
    return (
      <div className={clsx(container, "text-black")}>
        <div className="mt-5 text-2xl font-bold font-urbanist">Corporate</div>
        <div className="flex gap-12 mt-5">
          <div className="w-2/5">
            Dapatkan solusi tepat dalam memperkuat bisnis Anda bersama tim dengan skill terbaik.
          </div>
          <div className="grid grid-cols-2 gap-4 w-1/2">
            <LinkHead link="/hire-graduates">Hire Graduates</LinkHead>
            <LinkHead link="/corporate-training">Corporate Training</LinkHead>
          </div>
        </div>
      </div>
    )
  }

  return (
    <HeaderPopup
      menuKey="corporate"
      panel={<PopoverComponent />}
      buttonLabel="Corporate"
      transparent={transparent}
    />
  )
}
